import React, { useEffect, useState, useRef } from "react";
import axiosInstance from "../../api";
import ViewEditSiteContact from "./ViewEditSiteContact";
import Swal from "sweetalert2";
import Pagination from "../Homepage/Pagination";

export default function SiteContactDetails() {
  const [sitecontacts, setSiteContacts] = useState([]);
  const [loading, setloading] = useState(false);
  const [isEdit, setisEdit] = useState(false);
  const [siteContactId, setSiteContactId] = useState(0);
  const [showSiteContact, setShowSiteContact] = useState(false);
  const [refresh, setrefresh] = useState(false);
  const [page, setpage] = useState(1);
  const [search, setSearch] = useState("");
  const [isEnter, setIsEnter] = useState(false);
  const [pagecount, setpagecount] = useState(0);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    setloading(true);
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/SiteContact/GetAllSiteContactDetails?search=${search}&page=${page}`
      )
      .then((res) => {
        setSiteContacts(res.data?.data);
        setTotal(res.data?.count);
        setpagecount(res.data?.pages);
      })
      .catch(console.log)
      .finally(() => {
        setloading(false);
      });
  }, [refresh, isEnter, page]);

  return (
    <section className="technician-vouchers">
      <h1>Site Contact Details</h1>
      {showSiteContact && (
        <ViewEditSiteContact
          isEdit={isEdit}
          setShowSiteContact={setShowSiteContact}
          siteContactId={siteContactId}
          setrefresh={setrefresh}
          refresh={refresh}
        />
      )}

      <input
        type="search"
        placeholder="Enter Search Keyword"
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            setIsEnter(!isEnter);
            setpage(1);
          }
        }}
      />
      <p>
        <strong>Total: </strong>
        {total}
      </p>
      <section className="table">
        <section>
          <div>
            <aside style={{ gridTemplateColumns: "repeat(9, 1fr)" }}>
              <blockquote style={{ minWidth: "20rem" }}>
                Company Name
              </blockquote>
              <blockquote style={{ minWidth: "20rem" }}>Name</blockquote>
              <blockquote style={{ minWidth: "25rem" }}>Designation</blockquote>
              <blockquote style={{ minWidth: "25rem" }}>
                Phone Number
              </blockquote>
              <blockquote style={{ minWidth: "25rem" }}>Email</blockquote>
              <blockquote style={{ minWidth: "25rem" }}>Added By</blockquote>
              <blockquote style={{ minWidth: "15rem", gridColumn: "span 3" }}>
                Actions
              </blockquote>
            </aside>
          </div>
          <div>
            {sitecontacts.length > 0 ? (
              <>
                {sitecontacts.map((x) => (
                  <aside style={{ gridTemplateColumns: "repeat(9, 1fr)" }}>
                    <blockquote style={{ minWidth: "20rem" }}>
                      {x.companyName || "N/A"}
                    </blockquote>
                    <blockquote style={{ minWidth: "20rem" }}>
                      {x.name}
                    </blockquote>
                    <blockquote style={{ minWidth: "25rem" }}>
                      {x.designation}
                    </blockquote>
                    <blockquote style={{ minWidth: "25rem" }}>
                      {x.phone}
                    </blockquote>
                    <blockquote style={{ minWidth: "25rem" }}>
                      {x.email}
                    </blockquote>
                    <blockquote style={{ minWidth: "25rem" }}>
                      {x.technicianUsername}
                    </blockquote>
                    <blockquote
                      onClick={() => {
                        setisEdit(false);
                        setSiteContactId(x.id);
                        setShowSiteContact(true);
                      }}
                    >
                      <i className="fa-solid fa-eye"></i>
                    </blockquote>
                    <blockquote
                      onClick={() => {
                        setisEdit(true);
                        setSiteContactId(x.id);
                        setShowSiteContact(true);
                      }}
                    >
                      <i className="fa-solid fa-pen-to-square"></i>
                    </blockquote>
                    <blockquote
                      onClick={() => {
                        Swal.fire({
                          title: "Delete Site Contact",
                          text: "Are you sure you want to delete site contact details?",
                          showCancelButton: true,
                          showConfirmButton: true,
                          icon: "error",
                        }).then((result) => {
                          if (result.isConfirmed) {
                            axiosInstance
                              .delete(
                                `${process.env.REACT_APP_API_URL}/api/SiteContact/DeleteSiteContactDetails/${x.id}`
                              )
                              .then((res) => {
                                setrefresh(!refresh);
                              })
                              .catch(console.log);
                          }
                        });
                      }}
                    >
                      <i className="fa-solid fa-trash"></i>
                    </blockquote>
                  </aside>
                ))}
                {loading && (
                  <aside style={{ gridTemplateColumns: "repeat(9, 1fr)" }}>
                    <blockquote style={{ gridColumn: "span 9" }}>
                      <center>
                        <i className="fa-solid fa-spinner fa-3x fa-spin"></i>
                      </center>
                    </blockquote>
                  </aside>
                )}
              </>
            ) : (
              <aside style={{ gridTemplateColumns: "repeat(9, 1fr)" }}>
                <blockquote style={{ gridColumn: "span 9" }}>
                  No Records Found
                </blockquote>
              </aside>
            )}
          </div>
        </section>
      </section>
      <Pagination count={pagecount} setpagenumber={setpage} pagenumber={page} />
    </section>
  );
}
